import './VisitorNavigation.css';
import React, {useContext} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'
import BellSlashIcon from "../icons/BellSlashIcon";
import { AppContext } from '../AppContext';
import ReactDOM from "react-dom";
import {useNavigate} from "react-router-dom";

class VisitorNavigation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expand_notifications: false,
            unread_notifications: 0,
        };
    }

    get visitorNavigationHost() {
        return document.querySelector('header div.Visitor-Navigation');
    }

    _getApi() {
        return window.WebsiteApi;
    }

    readNotifications(event) {
        event.preventDefault();
        this.setState({
            expand_notifications: !this.state?.expand_notifications,
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const notifications = this.props?.context?.notifications;
        let unread_count = 0;
        if (notifications && notifications.length > 0) {
            notifications.map((notification) => {
                const is_unread = `${notification.status}` === "0";
                if (is_unread) {
                    unread_count++;
                }
                return is_unread;
            });
        }
        if (this.state.unread_notifications !== unread_count) {
            this.setState({
                unread_notifications: unread_count,
            });
        }
    }

    getNotificationsContent() {
        const notifications = this.props?.context?.notifications;
        const hasUnread = (this.state.unread_notifications > 0);
        if (notifications && notifications.length > 0) {
            return (
                <div className="Visitor-Navigation-Notifications Has-Unread" data-count={this.state.unread_notifications} onClick={(event) => { this.readNotifications(event); }}>
                    { hasUnread ?
                        <FontAwesomeIcon icon={icon({name: 'bell', style: 'solid'})} shake style={{color: "#fff",}} />
                      :
                        <FontAwesomeIcon icon={icon({name: 'bell', style: 'regular'})} style={{color: "#fff",}} />
                    }
                </div>
            );
        }
        return (
            <div className="Visitor-Navigation-Notifications">
                <BellSlashIcon style={{fill: "#999",}} />
            </div>
        );
    }

    markNotificationRead(e, notification_id) {
        e.preventDefault();
        return this._getApi().markNotificationRead({
            'id': notification_id,
        }).then((data) => {
            if (data === true) {
                // Succeeded!
                this._updateNotificationData(notification_id, {status: 1});
                return;
            }
            alert('Ei onnistunut! Yritä uudestaan!'); // @todo: ERROR HANDLING
            console.dir(data); // DEBUG
        }).catch((error) => {
            alert('Ei onnistunut! Yritä uudestaan!'); // @todo: ERROR HANDLING
            console.dir(error); // DEBUG
        });
    }

    _updateNotificationData(notification_id, data) {
        let notifications = this.props.context?.notifications;
        let notifications_updated = false;
        for (let index in notifications) {
            let notification = notifications[index];
            if (!notification?.id) {
                continue;
            }
            if (`${notification.id}` !== `${notification_id}`) {
                continue;
            }
            notifications_updated = true;
            for (let key in data) {
                notifications[index][key] = data[key];
            }
            break;
        }
        if (notifications_updated) {
            this.props.context.updateContext('notifications', notifications);
        }
    }

    _getMessageNotificationIcon(icon_name) {
        if (!icon_name) {
            return null;
        }
        switch (icon_name) {
            case 'comments':
                return (
                    <FontAwesomeIcon icon={icon({name: 'comments'})}/>
                );
            case 'pencil':
                return (
                    <FontAwesomeIcon icon={icon({name: 'pencil'})}/>
                );
        }
        console.error(`Should have shown ${icon_name} but not prepared to do that..`);
        return null;
    }

    getNotificationsDropdownContent() {
        if (!this.state?.expand_notifications) {
            return null;
        }
        let notification_elements = [];
        const notifications = this.props?.context?.notifications;
        for (let notification of notifications) {
            let notification_icon = (
                <FontAwesomeIcon icon={icon({name: 'bell', style: 'solid'})} style={{color: "#fff",}} />
            );
            let notification_css_class = 'Notification-Unread';
            if (`${notification?.status}` === "1") {
                // Read
                notification_icon = (
                    <FontAwesomeIcon icon={icon({name: 'bell', style: 'regular'})} style={{color: "#999",}} />
                );
                notification_css_class = 'Notification-Read';
            }
            let notification_msg_icon = null;
            if (notification?.icon) {
                notification_msg_icon = this._getMessageNotificationIcon(notification.icon);
            }
            notification_elements.push((
                <li className={notification_css_class}>
                    {notification_icon}
                    <a href="" onClick={(e) => {
                        const navigateToLink = () => {
                            if (!notification?.link) {
                                return;
                            }
                            if (notification.link.indexOf('#') !== -1) {
                                localStorage.setItem(`anchor_uri`, notification.link);
                            }
                            this.props.navigate(notification.link.replace(/#.*$/, ''));
                        };
                        this.setState({
                            expand_notifications: false, // Hide dropdown
                        });
                        if (`${notification?.status}` !== "1") {
                            this.markNotificationRead(e, notification.id).then(navigateToLink);
                            return;
                        }
                        navigateToLink();
                    }}>
                        {notification_msg_icon}{notification.msg}
                    </a>
                </li>
            ));
        }

        return (
            <div className="Visitor-Navigation-Notifications-Dropdown">
                <ul>
                    {notification_elements}
                </ul>
            </div>
        );
    }

    getPlayerNameLink(alias, avatar) {
        return (
            <a href='/pelaaja' className="UserModal-link" aria-label="Linkki profiiliisi" onClick={(e) => {
                e.preventDefault();
                this.props.navigate('/pelaaja');
            }}>
                {avatar}
                <small>
                    {alias ? alias : (<span className="skeleton" aria-hidden="true"></span>)}
                </small>
            </a>
        );
    }

    render() {
        if (!this.visitorNavigationHost) {
            return null;
        }
        let alias;
        let avatar;
        const visitor = this.props?.context?.visitor;
        if (!visitor || !visitor.anonymous_name) {
            // Not loaded yet, a placeholder will be shown
        } else {
            alias = visitor.anonymous_name;
            if (visitor.account && visitor.account.username) {
                alias = visitor.account.username;
            }
        }
        avatar = (<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+ICAgIDwhLS0gQmFja2dyb3VuZCAtLT4gICAgPHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iI2Q0ZDRkNCIvPiAgICAgICAgPCEtLSBCb3ggSGVhZCAtLT4gICAgPHJlY3QgeD0iNTAiIHk9IjQwIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0iI2Y0YzA3YSIgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjMiLz4gICAgICAgIDwhLS0gRXllcyAtLT4gICAgPHJlY3QgeD0iNzAiIHk9IjcwIiB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIGZpbGw9IiMwMDAiLz4gICAgPHJlY3QgeD0iMTE1IiB5PSI3MCIgd2lkdGg9IjE1IiBoZWlnaHQ9IjE1IiBmaWxsPSIjMDAwIi8+ICAgICAgICA8IS0tIE1vdXRoIC0tPiAgICA8cmVjdCB4PSI5MCIgeT0iOTUiIHdpZHRoPSIyMCIgaGVpZ2h0PSI1IiBmaWxsPSIjMDAwIi8+ICAgICAgICA8IS0tIEJhbmRhbmEgLS0+ICAgIDxyZWN0IHg9IjUwIiB5PSIxMjAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMzAiIGZpbGw9IiM5MDg1OTgiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIzIi8+ICAgICAgICA8IS0tIEJhbmRhbmEgS25vdCAtLT4gICAgPHBvbHlnb24gcG9pbnRzPSIxMDAsMTIwIDEzMCwxMDAgMTQwLDEyMCIgZmlsbD0iIzkwODU5OCIgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjMiLz4gICAgICAgIDwhLS0gQm9keSAtLT4gICAgPHJlY3QgeD0iNzAiIHk9IjE0MCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjUwIiBmaWxsPSIjNTU5ODg1IiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMyIvPjwvc3ZnPg==" alt="Käyttäjän avatar latautuu" className="User-Profile-Avatar" width="32" height="32" />);
        if (visitor?.account?.img_thumb) {
            avatar = (<img src={visitor.account.img_thumb} alt={`Käyttäjän avatar: ${alias}`} className="User-Profile-Avatar" />);
        }
        const visitorNavigationElements = (
            <>
                {this.getPlayerNameLink(alias, avatar)}
                {this.getNotificationsContent()}
                {this.getNotificationsDropdownContent()}
            </>
        );
        if (!this.visitorNavigationHost.getAttribute('data-rendered')) {
            this.visitorNavigationHost.setAttribute('data-rendered', true);
            this.visitorNavigationHost.replaceChildren();
        }
        return ReactDOM.createPortal(visitorNavigationElements, this.visitorNavigationHost);
    }
}

const VisitorNavigationWithContext = (props) => {
    const navigate = useNavigate();
    const context = useContext(AppContext);
    return (<VisitorNavigation {...props} context={context} navigate={navigate} />);
};

export default VisitorNavigationWithContext;
